export default {
	subtitle: "Webhooks on Subscriptions",
	path: "webhooks_subscriptions",
	paragraphs: [
		"We always send webhook notifications for all subscriptions whenever there is a status change. This notification is sended when the subscription is activated, meaning that the first invoice has been successfully processed and the subscription is now active.",
	],
	request: {
		method: "POST",
		payloads: [
			{
				title: "Notification",
				content: {
					"notification": {
						"secret": "the value you received",
						"type": "subscription_activated",
						"subscription": {
							"id": "e97e7ad9-3cfc-4701-8a4f-77eaa9402b35",
							"status": "active",
							"subject_id": "e0e34575-bee4-423d-a989-cfd525b965cf"
						},
					}
				}
			}
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/WebhooksSubscriptions.js